import React from 'react';
import Table from '../../common/PDF/Table';
import { splitByThousands, addPercent } from '../../../helpers/NumberFormatter';

export default ({data})=>{
	const columns=[
		{key: 'period', title: 'Period', width: 20, fontSize: 5},                   
		{key: 'physical', title: 'Physical', width: 16, fontSize: 5, formatFn: splitByThousands},
		{key: 'digital', title: 'Digital', width: 16, fontSize: 5, formatFn: splitByThousands},
		{key: 'nr', title: 'NR', width: 16, fontSize: 5, formatFn: splitByThousands},
		{key: 'catalog', title: 'Catalog', width: 16, fontSize: 5, formatFn: splitByThousands},
		{key: 'frontline', title: 'Frontline', width: 16, fontSize: 5, formatFn: splitByThousands},
   ];
	   
	return <Table
		columns={columns}
		items={data}
	/>
}